export default __webpack_public_path__ + "static/media/csc-chain.30fe3229.svg";